import PetsService from '../services/pets.service';

const SPECIES_MAP = {
  'perro': 'dog',
  'Perro': 'dog',
  'PERRO': 'dog',
  'CAT': 'cat',
  'Cat': 'cat',
  'dog': 'dog',
  'gato': 'cat',
  'cat': 'cat'
};

export const petMixin = {
  methods: {
    normalizeSpecies(species) {
      return SPECIES_MAP[species.toLowerCase()] || species;
    },

    async getBreeds(species) {
      if (!species) return;
      
      this.loadingBreeds = true;
      try {
        const normalizedSpecies = this.normalizeSpecies(species);
        const response = await PetsService.getBreeds(normalizedSpecies);
        this.breeds = response.status === 'ok' ? response.data || [] : [];
      } catch (error) {
        this.showErrorSnackbar('Error al cargar las razas');
        this.breeds = [];
      } finally {
        this.loadingBreeds = false;
      }
    },

    async handleUpdateMembership(item) {
      if (!this.petInfo?.length) {
        this.showErrorSnackbar("Datos de mascotas no disponibles");
        return;
      }

      // Por id, no por nombre: un tutor puede tener varias mascotas con el mismo nombre.
      const petData = this.petInfo.find(pet => pet.id === item.petId);

      if (!petData?.id) {
        this.showErrorSnackbar("No se pudo identificar la mascota para editar");
        return;
      }

      this.showOverlay = true;

      try {
        await this.setupEditPetData(petData, item);
      } catch (error) {
        this.showErrorSnackbar('Error al cargar datos de la mascota');
      } finally {
        this.showOverlay = false;
      }
    },

    async setupEditPetData(petData, item) {
        this.editingPet = {
            id: petData.id,
            name: item.name,
            breed: petData.raza || '',
            breedId: petData.breedId || null,
            species: this.normalizeSpecies(item.species || petData.species),
            originalName: item.name,
            membershipId: item.id,
            sex: petData.sexCode || 'male',
            microchip: petData.microchip || '',
            hasMicrochip: petData.hasMicrochip || false,
            isPurebred: petData.isPurebred || false,
            visible: petData.visible !== false
        };

        this.petData.birthdate = petData.birthdate || null;

        await this.getBreeds(this.editingPet.species);
        
        const selectedBreed = this.breeds.find(b => b.name === petData.raza);
        
        if (selectedBreed) {
            this.editingPet.breedId = selectedBreed.id;
        }
        
        this.showEditPetDialog = true;
    },

    async confirmEditPet() {
      if (!this.$refs.petForm.validate()) return;
        
      this.editPetLoading = true;
        
      try {
        if (!this.editingPet?.id) {
          throw new Error("ID de mascota no disponible");
        }

        const updateData = {
          name: this.editingPet.name,
          breed: this.editingPet.breed,
          breedId: this.editingPet.breedId,
          species: this.editingPet.species,
          birthdate: this.petData.birthdate
        };

        const result = await PetsService.updatePet(this.editingPet.id, updateData);

        if (result.status !== 'ok') {
          throw new Error(result.message || "Error en la respuesta del servidor");
        }

        await this.updatePetDataLocally();
        await this.fetchPetData();

        this.showSuccessSnackbar('Mascota actualizada correctamente');
        this.showEditPetDialog = false;
      } catch (error) {
        this.showErrorSnackbar(error.message || "Error al actualizar mascota");
      } finally {
        this.editPetLoading = false;
      }
    },

    cancelEditPet() {
      this.showEditPetDialog = false;
      this.editingPet = this.getInitialEditingPet();
      this.petData.birthdate = null;
      this.birthdateMenu = false;
      
      if (this.$refs.petForm) {
        this.$refs.petForm.resetValidation();
      }
    },

    getInitialEditingPet() {
      return {
        name: '',
        breed: '',
        originalName: '',
        membershipId: null,
        species: ''
      };
    }
  }
};